import React from 'react';
import styled from 'styled-components';

import { Logo, Colors, BREAK_POINTS } from '@origin-digital/style-guide';

import { StepIndicator } from './StepIndicator';
import { WizardContext, IWizardContext } from '../WizardContext';

const StepIndicatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
`;

const StyledNav = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  background: ${Colors.WHITE};
  box-sizing: border-box;
  border-bottom: 1px solid ${Colors.GREY16};

  & > *:first-child {
    position: absolute;
    left: 0;
    top: 0;
    border-right: 1px solid ${Colors.GREY16};
    min-height: 0;
    width: 63px;
  }
`;

export const WizardNav = (props) => {
  const wizardContext: IWizardContext = React.useContext(WizardContext);
  const {
    config: { steps },
  } = wizardContext;

  return (
    <StyledNav>
      <Logo height={63} />
      <StepIndicatorContainer>
        {steps.slice(0, steps.length - 1).map((_, index) => (
          <StepIndicator {...props} step={index + 1} key={index} />
        ))}
      </StepIndicatorContainer>
    </StyledNav>
  );
};
